import {
  ActualEscrow,
  Amortization,
  parseAmortizationResponse,
  parseActualEscrowResponse,
  parseServicingPaymentResponse,
  ServicingPayment,
} from "@eave/shared/types/api";

import APIClient from "web_modules/APIClient";

export const getAmortizationSchedule = async (appId: number): Promise<[Amortization, string[]]> => {
  return APIClient.get(`/uw/${appId}/amortization_schedule`).then((resp: any) => {
    return [parseAmortizationResponse(resp.amortization_schedule), resp.explainers];
  });
};

export const getSortedServicingPayments = async (appId: number): Promise<ServicingPayment[]> => {
  return APIClient.get(`/uw/loan_applications/${appId}/servicing_payments`).then((resp: any) => {
    return resp.servicing_payments.map(parseServicingPaymentResponse);
  });
};

export const createServicingPayment = async (
  appId: number,
  payment: ServicingPayment,
): Promise<ServicingPayment> => {
  return APIClient.post(`/uw/loan_applications/${appId}/servicing_payments`, payment).then(
    (resp: any) => {
      return parseServicingPaymentResponse(resp.servicing_payment);
    },
  );
};

export const updateServicingPayment = async (
  appId: number,
  payment: ServicingPayment,
): Promise<ServicingPayment> => {
  return APIClient.put(
    `/uw/loan_applications/${appId}/servicing_payments/${payment.id}`,
    payment,
  ).then((resp: any) => {
    return parseServicingPaymentResponse(resp.servicing_payment);
  });
};

export const deleteServicingPayment = async (
  appId: number,
  payment: ServicingPayment,
): Promise<{}> => {
  return APIClient.deleteRequest(`/uw/loan_applications/${appId}/servicing_payments/${payment.id}`);
};

export const getActualEscrows = async (appId: number): Promise<ActualEscrow[]> => {
  return APIClient.get(`/uw/loan_applications/${appId}/servicing_actual_escrows`).then(
    (resp: any) => {
      return resp.servicing_actual_escrows.map(parseActualEscrowResponse);
    },
  );
};

export const createServicingActualEscrow = async (
  appId: number,
  actualEscrow: ActualEscrow,
): Promise<ActualEscrow> => {
  return APIClient.post(
    `/uw/loan_applications/${appId}/servicing_actual_escrows`,
    actualEscrow,
  ).then((resp: any) => {
    return parseActualEscrowResponse(resp.servicing_actual_escrow);
  });
};

export const updateServicingActualEscrow = async (
  appId: number,
  actualEscrow: ActualEscrow,
): Promise<ActualEscrow> => {
  return APIClient.put(
    `/uw/loan_applications/${appId}/servicing_actual_escrows/${actualEscrow.id}`,
    actualEscrow,
  ).then((resp: any) => {
    return parseActualEscrowResponse(resp.servicing_actual_escrow);
  });
};

export const deleteServicingActualEscrow = async (
  appId: number,
  actualEscrow: ActualEscrow,
): Promise<{}> => {
  return APIClient.deleteRequest(
    `/uw/loan_applications/${appId}/servicing_actual_escrows/${actualEscrow.id}`,
  );
};
